var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMaverickxLogomarkC = function SvgMaverickxLogomarkC(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 678.826 579.543",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.134,
    y2: 1.04,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b998f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5b00d8"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "MaverickX_Logomark_C",
    "data-name": "MaverickX Logomark C",
    d: "M1098.826,873.195l-255-294.024-99.55,189.568L572.748,580.1,420,890.073,572.748,717.867,674.579,890.073,572.748,1158.714,835.813,869.408l-68.028-74.813L840.016,716.9l97.045,174.017L827.83,1157.636Z",
    transform: "translate(-420 -579.17)",
    fill: "url(#linear-gradient)"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMaverickxLogomarkC);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/maverickx-logomark-c.e270bd9d473a29f84800554a9d7aa3c0.svg";